export const GO_BUTTON_DISCOUNT_ACTION = "GO_BUTTON_DISCOUNT_ACTION"
export const GO_BUTTON_DISCOUNT_ACTION_SUCCESS = 'GO_BUTTON_DISCOUNT_ACTION_SUCCESS'

export const SAVE_DISCOUNT_SUBMIT = "SAVE_DISCOUNT_SUBMIT"
export const SAVE_DISCOUNT_SUBMIT_SUCCESS = 'SAVE_DISCOUNT_SUBMIT_SUCCESS'

export const GET_DISCOUNT_LIST = "GET_DISCOUNT_LIST"
export const GET_DISCOUNT_LIST_SUCCESS = 'GET_DISCOUNT_LIST_SUCCESS'

export const DELETE_DISCOUNT_ID = "DELETE_DISCOUNT_ID"
export const DELETE_DISCOUNT_ID_SUCCESS = 'DELETE_DISCOUNT_ID_SUCCESS'

export const EDIT_DISCOUNT_ID = "EDIT_DISCOUNT_ID"
export const EDIT_DISCOUNT_ID_SUCCESS = 'EDIT_DISCOUNT_ID_SUCCESS'

export const UPDATE_DISCOUNT_ID = "UPDATE_DISCOUNT_ID"
export const UPDATE_DISCOUNT_ID_SUCCESS = 'UPDATE_DISCOUNT_ID_SUCCESS'

export const GET_DISCOUNTGROUP = "GET_DISCOUNTGROUP"
export const GET_DISCOUNTGROUP_SUCCESS = "GET_DISCOUNTGROUP_SUCCESS"

export const DISCOUNT_PARTY_TYPE_DROPDOWN_ACTION = "DISCOUNT_PARTY_TYPE_DROPDOWN_ACTION"
export const DISCOUNT_PARTY_TYPE_DROPDOWN_SUCCESS = "DISCOUNT_PARTY_TYPE_DROPDOWN_SUCCESS"

export const DISCOUNT_CUSTOMER_DROPDOWN_ACTION = "DISCOUNT_CUSTOMER_DROPDOWN_ACTION"
export const DISCOUNT_CUSTOMER_DROPDOWN_SUCCESS = "DISCOUNT_CUSTOMER_DROPDOWN_SUCCESS"

export const DISCOUNT_API_ERROR_ACTION = "DISCOUNT_API_ERROR_ACTION"





